import { SolarIrImageApi } from '@/apis/solar.ir.image.api';

function normalizeThermalImageFromApi(response) {
  const raw = response?.data?.content ?? response?.data ?? response;
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  return raw;
}

/**
 * dashboard 열화상 목록에서 id로 전체 이미지 객체 검색
 * @returns {{ image: object|null, index: number }}
 */
export function findThermalImageInDashboard(store, thermalImageId) {
  const id = Number(thermalImageId);
  if (!Number.isFinite(id) || id <= 0) {
    return { image: null, index: -1 };
  }

  const images = store.state.dashboard?.thermalImages;
  if (!Array.isArray(images) || images.length === 0) {
    return { image: null, index: -1 };
  }

  const index = images.findIndex(img => img && Number(img.id) === id);
  if (index < 0) {
    return { image: null, index: -1 };
  }

  return { image: images[index], index };
}

/** ImageExplorer.selectImage 와 동일 — 탐색기·모달 네비 동기화 */
export function syncDashboardSelectedThermalImage(store, image, index = -1) {
  if (!image?.id) {
    return;
  }

  let resolvedIndex = index;
  if (resolvedIndex < 0) {
    const images = store.state.dashboard?.thermalImages || [];
    resolvedIndex = images.findIndex(img => img && Number(img.id) === Number(image.id));
  }

  store.commit('dashboard/SET_SELECTED_THERMAL_IMAGE', {
    image,
    index: resolvedIndex >= 0 ? resolvedIndex : 0
  });
}

function hasRenderableThermalFields(image) {
  return Boolean(
    image?.imgUrl ||
    image?.thumbImgUrl ||
    image?.imgPosCoords ||
    image?.pairRgbImageId
  );
}

/**
 * 결함 모달에 필요한 열화상 객체 해석 (ImageExplorer 와 동일 데이터 형태)
 * 1) dashboard.thermalImages 목록
 * 2) GET /solarThermalImages/{id}
 */
export async function resolveThermalImageForDefectDialog(store, thermalImageId) {
  const id = Number(thermalImageId);
  if (!Number.isFinite(id) || id <= 0) {
    return null;
  }

  const { image: fromList, index } = findThermalImageInDashboard(store, id);
  if (fromList && hasRenderableThermalFields(fromList)) {
    syncDashboardSelectedThermalImage(store, fromList, index);
    return fromList;
  }

  try {
    const response = await SolarIrImageApi.getSolarIrImage(id);
    const fromApi = normalizeThermalImageFromApi(response);
    if (fromApi) {
      const merged =
        fromList && typeof fromList === 'object'
          ? { ...fromApi, ...fromList, id }
          : { ...fromApi, id };
      syncDashboardSelectedThermalImage(store, merged, index);
      return merged;
    }
  } catch (error) {
    console.warn('[DefectFeature] 열화상 API 조회 실패:', id, error);
  }

  if (fromList) {
    syncDashboardSelectedThermalImage(store, fromList, index);
    return fromList;
  }

  return null;
}
